import _regeneratorRuntime from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/AirVenture/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { POST, GET, PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
export default {
  mixins: [ValidationMixin],
  name: "role-create",
  data: function data() {
    return {
      role_id: 0,
      clone_id: 0,
      updateRole: {
        role_name: null,
        description: null
      },
      formPermissions: [],
      permissions: [],
      pageLoading: false,
      permissionLoading: true,
      routePreventDialog: false
    };
  },
  components: {
    CreateUpdateTemplate: CreateUpdateTemplate
  },
  methods: {
    changeFullAccess: function changeFullAccess(param, index) {
      var _this = this;

      try {
        if (param.name == "full-access") {
          var append = true;

          if (_this.lodash.includes(_this.formPermissions, param.id) === false) {
            append = false;
          }

          var _loop = function _loop(i) {
            if (append) {
              if (_this.lodash.includes(_this.formPermissions, _this.permissions[index][i].id) === false) {
                _this.formPermissions.push(_this.permissions[index][i].id);
              }
            } else {
              var removeIndex = _this.lodash.findIndex(_this.formPermissions, function (row) {
                return row == _this.permissions[index][i].id;
              });

              if (removeIndex >= 0) {
                _this.formPermissions.splice(removeIndex, 1);
              }
            }
          };

          for (var i = 0; i < _this.permissions[index].length; i++) {
            _loop(i);
          }
        } else {
          if (_this.lodash.includes(_this.formPermissions, param.id) === false) {
            var _loop2 = function _loop2(_i) {
              if (_this.permissions[index][_i].name == "full-access") {
                var removeIndex = _this.lodash.findIndex(_this.formPermissions, function (row) {
                  return row == _this.permissions[index][_i].id;
                });

                if (removeIndex >= 0) {
                  _this.formPermissions.splice(removeIndex, 1);
                }
              }
            };

            for (var _i = 0; _i < _this.permissions[index].length; _i++) {
              _loop2(_i);
            }
          } else {
            var currentIndexValues = [];

            for (var _i2 = 0; _i2 < _this.permissions[index].length; _i2++) {
              if (_this.lodash.includes(_this.formPermissions, _this.permissions[index][_i2].id)) {
                currentIndexValues.push(_this.permissions[index][_i2].id);
              }
            }

            if (_this.permissions[index].length === currentIndexValues.length + 1) {
              for (var _i3 = 0; _i3 < _this.permissions[index].length; _i3++) {
                if (_this.lodash.includes(_this.formPermissions, _this.permissions[index][_i3].id) === false) {
                  _this.formPermissions.push(_this.permissions[index][_i3].id);
                }
              }
            }
          }
        }
      } catch (error) {
        ErrorEventBus.$emit("update:error", InitializeError(error));
      }
    },
    checkAllPermissions: function checkAllPermissions() {
      var _this = this;

      var result = [];

      for (var index in _this.permissions) {
        for (var i = 0; i < _this.permissions[index].length; i++) {
          if (_this.lodash.includes(result, _this.permissions[index][i].id) === false) {
            result.push(_this.lodash.toSafeInteger(_this.permissions[index][i].id));
          }
        }
      }

      _this.formPermissions = _this.lodash.cloneDeep(result);
    },
    updatePermissions: function updatePermissions(permissionData) {
      var _this = this;

      var result = [];

      for (var index in _this.permissions) {
        for (var i = 0; i < _this.permissions[index].length; i++) {
          if (_this.lodash.includes(permissionData, _this.permissions[index][i].id)) {
            result.push(_this.lodash.toSafeInteger(_this.permissions[index][i].id));
          }
        }
      }

      _this.formPermissions = _this.lodash.cloneDeep(result);
    },
    createRole: function createRole() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(POST, {
          url: "role",
          data: {
            text: _this.updateRole.role_name,
            description: _this.updateRole.description
          }
        }).then(function (_ref) {
          var data = _ref.data;
          resolve(data.id);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    assignPermissions: function assignPermissions() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(PATCH, {
          url: "role/" + _this.role_id + "/permission",
          data: {
            permission: _this.formPermissions
          }
        }).then(function (_ref2) {
          var data = _ref2.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this = _this2;
                _context.prev = 1;

                if (_this.$refs.roleForm.validate()) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", false);

              case 4:
                _this.formLoading = true;

                if (_this.role_id) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return _this.createRole();

              case 8:
                _this.role_id = _context.sent;

              case 9:
                _context.next = 11;
                return _this.assignPermissions();

              case 11:
                _this.$router.push(_this.getDefaultRoute("profile.setting", {
                  query: {
                    tab: "role-permission"
                  }
                }));

                _this.formLoading = false;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);
                _this.formLoading = false;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 15]]);
      }))();
    },
    getPermissions: function getPermissions() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(GET, {
          url: "permission"
        }).then(function (_ref3) {
          var data = _ref3.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    loadRole: function loadRole(role_id) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.$store.dispatch(GET, {
          url: "role/" + role_id
        }).then(function (_ref4) {
          var data = _ref4.data;
          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    loadContent: function loadContent(role_id) {
      var _this = this;

      _this.loadRole(role_id).then(function (_ref5) {
        var name = _ref5.name,
            description = _ref5.description,
            permissions = _ref5.permissions;
        _this.updateRole = {
          role_name: name,
          description: description
        };

        if (permissions && permissions.length > 0) {
          var result = permissions.map(function (row) {
            return _this.lodash.toSafeInteger(row.permission_id);
          });

          _this.updatePermissions(result);
        }
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.pageLoading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    _this.getPermissions().then(function (response) {
      _this.permissions = response || [];

      if (_this.$route.params.id) {
        _this.pageLoading = true;
        _this.role_id = _this.lodash.toSafeInteger(_this.$route.params.id);

        _this.loadContent(_this.role_id);
      }

      if (_this.$route.query.clone) {
        _this.pageLoading = true;
        _this.clone_id = _this.lodash.toSafeInteger(_this.$route.query.clone);

        _this.loadContent(_this.clone_id);
      }
    }).finally(function () {
      _this.permissionLoading = false;

      if (!_this.role_id && !_this.clone_id) {
        _this.checkAllPermissions();
      }
    });

    _this.$store.dispatch(SET_BREADCRUMB, [{
      title: "Role",
      route: "role"
    }, {
      title: "Create"
    }]);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this = this;

    _this.routePreventDialog = true;
    PreventDialogEventBus.$on("stay-on-page", function () {
      _this.routePreventDialog = false;
      next(false);
    });
    PreventDialogEventBus.$on("leave-page", function () {
      _this.routePreventDialog = false;
      next();
    });
  }
};